export const getDurationIcon = (durationUnit: string): string => {
  switch (durationUnit) {
    case "seconds":
    case "minutes":
      return "timer";
    case "repetitions":
    case "repetitions_twice":
    case "steps":
      return "repetitions";
    default:
      return "repetitions"; // Default to "repetition" if not recognized
  }
};

export const getInstructionsIconName = (durationUnit: string): string => {
  switch (durationUnit) {
    case "seconds":
    case "minutes":
      return "timer";
    case "repetitions":
    case "repetitions_twice":
    case "steps":
      return "repetitions";
    default:
      return "repetitions"; // Default to "repetition" if not recognized
  }
};

export const getTipTitle = (language: "sv" | "en"): string => {
  switch (language) {
    case "sv":
      return "Tips";
    case "en":
      return "Tip";
  }
};

const durationTranslations = {
  seconds: {
    sv: "sekunder",
    en: "seconds",
    es: "segundos",
    de: "Sekunden",
  },
  minutes: {
    sv: "minuter",
    en: "minutes",
    es: "minutos",
    de: "Minuten",
  },
  repetitions: {
    sv: "repetitioner",
    en: "repetitions",
    es: "repeticiones",
    de: "Wiederholungen",
  },
  repetitions_twice: {
    sv: "repetitioner x2",
    en: "repetitions x2",
    es: "repeticiones x2",
    de: "Wiederholungen x2",
  },
  steps: {
    sv: "steg",
    en: "steps",
    es: "pasos",
    de: "Schritte",
  },
};

export const getDurationTipText = (
  durationUnit: "seconds" | "minutes" | "repetitions" | "repetitions_twice" | "steps",
  locale: "sv" | "en" | "es" | "de"
) => {
  if (locale in durationTranslations[durationUnit]) {
    return durationTranslations[durationUnit][locale];
  } else {
    return durationTranslations[durationUnit]["en"];
  }
};

export const nullToUndefined = (exercise: any): any => {
  if (exercise === null) {
    return undefined;
  }

  if (Array.isArray(exercise)) {
    return exercise.map(nullToUndefined);
  }

  if (typeof exercise === "object" && exercise !== null) {
    const formatted: any = {};
    for (const [key, value] of Object.entries(exercise)) {
      formatted[key] = nullToUndefined(value);
    }
    return formatted;
  }

  return exercise;
};

export const exerciseImage = (level?: { image_url?: string | null; video_thumbnail_file_url?: string | null }) =>
  level?.image_url || level?.video_thumbnail_file_url || null;
